// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"57":"70cd82813f81451c9806","614":"faa1442ca84efdaf9d2e","883":"be49b36c471bf6069daa","952":"931b548fa3d92da30642"}[chunkId] + "/css/" + {"57":"index","614":"Approve","883":"Staff","952":"TestSettings"}[chunkId] + ".css";
};